import { Component, Input, Output, EventEmitter, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-sl-search',
  standalone: true,
  imports: [NgIf],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <sl-input
      class="search-input"
      [type]="type"
      [placeholder]="placeholder"
      [value]="value"
      [size]="size"
      [disabled]="disabled"
      [clearable]="clearable"
      (sl-input)="onInput($event)"
      (sl-clear)="onClear()">
      
      <sl-icon name="search" slot="prefix"></sl-icon>
      
      <span *ngIf="label" slot="label">{{ label }}</span>
      <span *ngIf="helpText" slot="help-text">{{ helpText }}</span>
    </sl-input>
  `,
  styleUrls: ['./sl-search.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SlSearchComponent {
  @Input() type: string = 'search';
  @Input() placeholder: string = 'Search...';
  @Input() label?: string;
  @Input() helpText?: string;
  @Input() value: string = '';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() disabled: boolean = false;
  @Input() clearable: boolean = true;

  @Output() valueChange = new EventEmitter<string>();
  @Output() search = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    this.valueChange.emit(value);
    this.search.emit(value);
  }

  onClear(): void {
    this.valueChange.emit('');
    this.clear.emit();
  }
}
